const { default: formatMoney } = require("./formatMoney");
const { default: formatNumber } = require("./formatNumber");

const formatMetricValue = (metric, value) => {
  if (value === null) {
    return "-";
  }

  if (value && typeof value === "string") {
    // Remove commas from string before parsing (e.g., "48,835,000.00" -> "48835000.00")
    value = parseFloat(value);
  }

  switch (metric) {
    case "cost":
      return formatMoney(value);
    case "conversion":
    case "conversions":
      return formatNumber(value);
    case "cpc":
    case "avg_cpc":
      // CPC values from Google Ads API are in micros (millionths), divide by 1,000,000
      return formatMoney(value);
    case "ctr":
      return formatNumber(value) + "%";
    default:
      return formatNumber(value);
  }
};

export default formatMetricValue;
